// extracted by mini-css-extract-plugin
export default {"card":"t0-z","carouselContainer":"u0-z","carouselContent":"v0-z"};